// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2p3v-","left":"StickyBox_left__36E__","right":"StickyBox_right__ZtM7b"};